import { FirebaseObjectResolver } from './firebase/firebase-object-resolver';
import { ModelBase } from './model-base';

export class ObjectResolverBase<T extends ModelBase> extends FirebaseObjectResolver<T> {}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/base/object-resolver-base.ts